import type { Response } from '~/types/api/v2'

import { useFetchWithDefaults } from '~/composables/api/useFetchWithDefaults'

import {
  type DocumentIdentifier,
  getUrlById as getDocumentByIdUrl,
} from '../useFetchDocument'

export const useFetchDocumentRetention = () => {
  const getUrl = (documentId: string) => `${getDocumentByIdUrl(documentId)}/retention`

  const { patch } = useFetchWithDefaults()

  const update = ({
    workspaceId,
    documentId,
    date,
  }: DocumentIdentifier & { date: string | null }) => {
    const body: App.Data.Payloads.Documents.RetentionPayload = {
      end_date: date || null,
    }

    return patch<Response<App.Data.Document.Metadata.RetentionData>>({
      url: getUrl(documentId),
      workspaceId,
      fetchOptions: {
        body,
      },
    })
  }

  return {
    update,
  }
}
